import React, { Component } from 'react';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import { withRouter } from 'react-router-dom';
//import queryString from 'query-string';

import {api_host, api_auth} from '../../../../../common/globals/constants';
import CircularProgress from '@material-ui/core/CircularProgress';


import moment from 'moment'
import 'moment/locale/es'  


// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletToolbar from 'components/PortletToolbar';
import PortletContent from 'components/PortletContent';

import Typography from '@material-ui/core/Typography';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { COLORS } from '../../../../../utils/colors';
import { useTranslation, withTranslation } from 'react-i18next';
import compose from 'recompose/compose';

moment.locale('es')


class ResponseTimeForStep extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentObjectiveId: this.props.match.params.objetivo_id,
            prevObjectiveId: this.props.match.params.objetivo_id,
            currentStepId: this.props.params.step,
            loadObjectiveData: false,
            externalData: null,
            dataError: false,
            isLoading: true,
            time: 'h',
            step: null,
            hoverData: null,
            lastEvent: [],
            statePeriod: this.props.params.statePeriod,
            chartOptionsBase: this._chartOptionsBase(),
            chartOptions: this._chartOptionsBase(),
            isRefresh: this.props.params.isRefresh,
            date: this.props.params.date,
            dateMoment:((moment().locale('es')).format("dddd, DD/MM/YYYY, h:mm:ss a"))


        }
    }

    _chartOptionsBase = () => {
        const t = (this.props && this.props.t) ? this.props.t : (s => s);
        return {
        chart: {
            type: 'spline',
            zoomType: 'x',
            ignoreHiddenSeries: false,
            marginRight: 30,
            resetZoomButton: {
                theme: {
                    fill: 'white',
                    stroke: 'silver',
                    r: 0,
                    states: {
                        hover: {
                            fill: '#41739D',
                            style: {
                                color: 'white'
                            }
                        }
                    }
                }
            }
        },
        title: {
            text: "",
            style: {
                fontSize: '' 
             },
             margin: 25,
        },
        subtitle: {
            text: '',
            style: {
                color: '',
                fontWeight: '',
                fontSize: '',
            }
        },
        xAxis: {
            lineColor: '#c0c0c0',
            type: 'datetime',
            minorGridLineColor: '#E0E0E0',
            minorTickLength: 0,
            gridLineWidth: 0.3,
            showFirstLabel: true,
            dateTimeLabelFormats: {
                second: '%l:%M:%S%P',
                minute: '%l:%M%P',
                hour: '%H:%M',
                day: '<br/><b>%e/%b</b>',
                week: '%e. %b',
                month: '%b %y',
                year: '%Y'
            },
            /*title: {
                text: 'Periodo'
            }  */
        },
        yAxis: {
            min: 0,
            title: {
                text: `${t("response-time-for-step.graph.tooltip.point-format")}`
            },
            plotLines: []
        },
        plotOptions: {
            series: {
                turboThreshold: 20000,
                gapSize: 2,
                marker: {
                    symbol: 'circle',
                    width: 8,
                    height: 8,
                    enabled: false
                },
            },
        },
        credits: {
            enabled: false
        },
        legend: {
            enabled: true,
            useHTML: true,
            symbolWidth: 0,
            labelFormatter: function() {
                let symbol = '<div style="background:' + this.color + ';width:15px;height:3px;margin-top:5px"></div>'
                let name= '<button style="padding-left:4px;border-width:0px;background:white">'+this.name+'</button>'
                return '<div style="display: flex;flex-direction: row;flex-wrap: nowrap;justify-content: space-between;">' + symbol + ' ' + name + '</div>'
              }
        },
        navigator: {
            enabled: null      
        },
        tooltip: {
            enabled: false,
            xDateFormat: '%d/%b/%Y %H:%M',
            pointFormat: t("response-time-for-step.graph.tooltip.point-format")+': <b>{point.y:.2f} (s)</b>'
        },
        series: []
    }
    }

    setHoverData = (e) => {
        const { x, y, series } = e.target
        // The chart is not updated because `chartOptions` has not changed.
        let point = []
        point['x'] = x
        point['y'] = y
        let step = series.userOptions.name
        this.props.params.onInfo(point, step)

    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.match.params.objetivo_id !== prevState.prevObjectiveId) {
            return {
                chartOptions: prevState.chartOptionsBase,
                externalData: null,
                prevObjectiveId: nextProps.match.params.objetivo_id,
                time: nextProps.params.period,
                step: null,
                lastEvent: [],
                hoverData: null,
                statePeriod: nextProps.params.statePeriod
            }
        } else if (nextProps.params.period !== prevState.time) {
            return {
                chartOptions: prevState.chartOptionsBase,
                externalData: null,
                prevObjectiveId: nextProps.match.params.objetivo_id,
                time: nextProps.params.period,
                step: prevState.step,
                lastEvent: [],
                hoverData: null,
                statePeriod: nextProps.params.statePeriod,
            }
        } else if (nextProps.params.step !== prevState.step) {
            return {
                chartOptions: prevState.chartOptionsBase,
                externalData: null,
                prevObjectiveId: nextProps.match.params.objetivo_id,
                time: prevState.time,
                step: nextProps.params.step,
                lastEvent: [],
                hoverData: null,
                statePeriod: nextProps.params.statePeriod
            }
        } else if (nextProps.params.period === prevState.time && nextProps.params.statePeriod !== prevState.statePeriod) {
            return {
                chartOptions: prevState.chartOptionsBase,
                prevObjectiveId: nextProps.match.params.objetivo_id,
                time: prevState.time,
                step: prevState.step,
                hoverData: null,
                lastEvent: [],
                statePeriod: nextProps.params.statePeriod
            }
        } else if(nextProps.params.isRefresh !== prevState.isRefresh){
            return {
                chartOptions: prevState.chartOptionsBase,
                externalData: null,
                prevObjectiveId: nextProps.match.params.objetivo_id,
                time: nextProps.params.period,
                hoverData: null,
                lastEvent: [],
                statePeriod: nextProps.params.statePeriod,
                isRefresh: nextProps.params.isRefresh,          
            }

        }else if(nextProps.params.date !== prevState.date){
            return {
                chartOptions: prevState.chartOptionsBase,
                externalData: null,
                prevObjectiveId: nextProps.match.params.objetivo_id,
                time: nextProps.params.period,
                hoverData: null,
                lastEvent: [],
                statePeriod: nextProps.params.statePeriod,
                date: nextProps.params.date,          
            }

        }
        return null;
    }

    componentDidMount() {
        // Intenta Obtener datos desde la API
        this.getDataFromAPI();
    }

    componentDidUpdate(prevProps, prevState) {
        if((prevProps.params.isRefresh !== this.state.isRefresh) && this.state.dateMoment!==((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a"))){
            this.props.params.onDateMoment(((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")))
        }
        if ((prevProps.params.period !== this.state.time) ||
            (prevProps.match.params.objetivo_id !== this.props.match.params.objetivo_id) ||
            (prevProps.params.step !== this.state.step) ||
            (prevProps.params.statePeriod !== this.state.statePeriod) ||
            (prevProps.params.isRefresh !== this.state.isRefresh)||
            (prevProps.params.date !== this.state.date)) {
            this.getDataFromAPI();
        }

    }


    getDataFromAPI = (objectiveId) => {
        this.setState({
            isLoading: true,
        })
        const { objetivo_id } = this.props.match.params
        const { fromObjective } = this.props.location.state
        const { period, step, statePeriod, schedule } = this.props.params
        const { history } = this.props;
        let sla_rendimiento_ok = parseInt(fromObjective.sla_rendimiento_ok)
        let sla_rendimiento_error = parseInt(fromObjective.sla_rendimiento_error)
        let sla_disponibilidad_ok = parseInt(fromObjective.sla_disponibilidad_ok)
        let sla_disponibilidad_error = parseInt(fromObjective.sla_disponibilidad_error)
        let fecha_inicio = null
        let fecha_termino = null
        let token = sessionStorage.getItem('key')
        if (period === 'c') {
            fecha_inicio = statePeriod.startDate.toISOString().substring(0, 10)
            fecha_termino = statePeriod.endDate.toISOString().substring(0, 10)
            fetch(api_host+`/reporte/online/indicadores/getDetalleRendimientoGlobalPasoCustom/?objetivoId=${objetivo_id}&token=${token}&fechaInicio=${fecha_inicio}&fechaTermino=${fecha_termino}&horarioId=${schedule}&key=07374CEAC2EAEF2EB3441BA0C433F9834E6CF6E2&pasoId=${step}&t=${period}`)
                .then(response => response.json())
                .then(myJson => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa    
                    if (myJson.status == 1 || myJson.status == 5) {
                        localStorage.setItem('isAuthenticated', false);                        
                    } else {                 
                        //Procesa la Data Recibida
                        try {
                            this.processData(myJson, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                period,
                                step,
                                fecha_inicio,
                                fecha_termino)
                            if (this.state.lastEvent && this.state.lastEvent.length > 0) {
                                this.props.params.onFirstInfo(this.state.lastEvent)
                            }
                        } catch (error) {
                            this.setState({
                                //chartOptions : this._chartOptionsBase,
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }
                });

        } else {
            fetch(api_host+`/reporte/online/indicadores/getDetalleRendimientoGlobalPaso/?objetivoId=${objetivo_id}&token=${token}&key=07374CEAC2EAEF2EB3441BA0C433F9834E6CF6E2&horarioId=${schedule}&pasoId=${step}&t=${period}`)
                .then(response => response.json())
                .then(myJson => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa 
                    if (myJson.status == 1 || myJson.status == 5) {
                        localStorage.setItem('isAuthenticated', false);                        
                    } else {
                        //Procesa la Data Recibida
                        try {
                            this.processData(myJson, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                period,
                                step,
                                fecha_inicio,
                                fecha_termino)
                            if (this.state.lastEvent && this.state.lastEvent.length > 0) {
                                this.props.params.onFirstInfo(this.state.lastEvent)
                            }
                        } catch (error) {
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }

                });
        }
    }


    // Helper para procesar la data de la petición a la API

    processData = (externalData,
        sla_rendimiento_ok,
        sla_rendimiento_error,
        sla_disponibilidad_ok,
        sla_disponibilidad_error,
        period,
        step,
        fecha_inicio,
        fecha_termino) => {

        let arrayChartData = []
        let lastEventDict = []
        const colors = ['#2199e8', '#fed12d', '#ff7373', '#ccff00', '#b6fcd5',
            '#065535', '#ffc0cb', '#008080', '#00ffff', '#ffa500',
            '#800000', '#fff68f', '#bada55', '#8a2be2', '#3b5998'];
        let ValueNavigator = false
        /*if (period === 'w' || fecha_inicio !== null){
            ValueNavigator = true
        }*/
        const t = (this.props && this.props.t) ? this.props.t : (s => s);
        if (this.props.params.schedule && this.props.params.schedule != '0' && !externalData.Objetivo.Paso[0].estado) {
            this.setState({
                dataError: true,
                isLoading: false                
            })
            return 
        }else if (this.props.params.schedule  && externalData.Objetivo.Paso[0].estado) {
            const nombrePaso =  externalData.Objetivo.Paso[0].estado[0].paso_nombre
            const dataEstadoPasos = externalData.Objetivo.Paso.flatMap(item => item['estado'].flatMap(j => j['rendimientoDetalle']))
            let chartDataSeries = {}
            let arrayData = []
            dataEstadoPasos.forEach((item, forEachKey) => {
                var dict = {};
                let date = new Date(item.inicio)
                let year = date.getFullYear()
                let month = date.getMonth()
                let day = date.getDate()
                let hours = date.getHours()
                let minutes = date.getMinutes()
                let seconds = date.getSeconds()
                dict['x'] = Date.UTC(year, (month), day, hours, minutes, seconds)
                dict['y'] = item.respuesta
                arrayData.push(dict)
                lastEventDict['x'] = dict['x']
                lastEventDict['y'] = dict['y']
                lastEventDict['name'] = nombrePaso;
                if (period === 'h') {
                    lastEventDict['namePeriod'] = `${t('text.range')}: ${t('period.text.last-hour')}`
                } else if (period === 'd') {
                    lastEventDict['namePeriod'] = `${t('text.range')}: ${t('period.text.last-day')}`
                } else if (period === 'w') {
                    lastEventDict['namePeriod'] = `${t('text.range')}: ${t('period.text.last-week')}`
                } else if (period === 'c') {
                    lastEventDict['namePeriod'] = `${t('text.range')}: ${fecha_inicio} ${t('text.to2')} ${fecha_termino}`
                }
            });
            chartDataSeries['name'] = nombrePaso;
            chartDataSeries['color'] = colors[0]
            chartDataSeries['data'] = arrayData
            arrayChartData.push(chartDataSeries)
        } else {
        Object.keys(externalData.Objetivo.Paso).map((key) => {
            let chartDataSeries = {}
            let arrayData = []
            const rendimientoDetalle = externalData.Objetivo.Paso[key]['rendimientoDetalle']
            
            const rowLen = rendimientoDetalle.length
            rendimientoDetalle.forEach((item, forEachKey) => {
                var dict = {};
                let date = new Date(item.inicio)
                let year = date.getFullYear()
                let month = date.getMonth()
                let day = date.getDate()
                let hours = date.getHours()
                let minutes = date.getMinutes()
                let seconds = date.getSeconds()
                dict['x'] = Date.UTC(year, (month), day, hours, minutes, seconds)
                dict['y'] = item.respuesta
                arrayData.push(dict)
                if (forEachKey == (rowLen - 1) && key == 0) {
                    lastEventDict['x'] = dict['x']
                    lastEventDict['y'] = dict['y']
                    lastEventDict['name'] = externalData.Objetivo.Paso[key].paso_nombre;
                    if (period === 'h') {
                        lastEventDict['namePeriod'] = `${t('text.range')}: ${t('period.text.last-hour')}`
                    } else if (period === 'd') {
                        lastEventDict['namePeriod'] = `${t('text.range')}: ${t('period.text.last-day')}`
                    } else if (period === 'w') {
                        lastEventDict['namePeriod'] = `${t('text.range')}: ${t('period.text.last-week')}`
                    } else if (period === 'c') {
                        lastEventDict['namePeriod'] = `${t('text.range')}: ${fecha_inicio} ${t('text.to2')} ${fecha_termino}`
                    }
                }
            });
            chartDataSeries['name'] = externalData.Objetivo.Paso[key].paso_nombre;
            chartDataSeries['color'] = colors[key]
            chartDataSeries['data'] = arrayData
            arrayChartData.push(chartDataSeries)
        })
        }
        
        const arrayChartDataMarked = externalData.Objetivo.Peridos_Marcados.map(item => {
            let chartDataSeries = {}
            if (item.id_tipo_marcado === 7){
                chartDataSeries['from'] = ""
                chartDataSeries['to'] =  ""
                chartDataSeries['color'] = ""
                chartDataSeries['zIndex'] = 1
            }
            if (item.id_tipo_marcado === 9){
                let dateStart = new Date(item.fecha_inicio)
                let dateEnd = new Date(item.fecha_termino)
                chartDataSeries['from'] = Date.UTC(dateStart.getFullYear(dateStart), dateStart.getMonth(dateStart), dateStart.getDate(dateStart), dateStart.getHours(dateStart), dateStart.getMinutes(dateStart), dateStart.getSeconds(dateStart))
                chartDataSeries['to'] = Date.UTC(dateEnd.getFullYear(dateEnd), dateEnd.getMonth(dateEnd), dateEnd.getDate(dateEnd), dateEnd.getHours(dateEnd), dateEnd.getMinutes(dateEnd), dateEnd.getSeconds(dateEnd))
                chartDataSeries['color'] = COLORS.EVENTO_CLIENTE
                chartDataSeries['zIndex'] = 1
            }
            if (item.id_tipo_marcado === 10){
                let dateStart = new Date(item.fecha_inicio)
                let dateEnd = new Date(item.fecha_termino)
                chartDataSeries['from'] = Date.UTC(dateStart.getFullYear(dateStart), dateStart.getMonth(dateStart), dateStart.getDate(dateStart), dateStart.getHours(dateStart), dateStart.getMinutes(dateStart), dateStart.getSeconds(dateStart))
                chartDataSeries['to'] = Date.UTC(dateEnd.getFullYear(dateEnd), dateEnd.getMonth(dateEnd), dateEnd.getDate(dateEnd), dateEnd.getHours(dateEnd), dateEnd.getMinutes(dateEnd), dateEnd.getSeconds(dateEnd))
                chartDataSeries['color'] = COLORS.MARCADO_ATENTUS
                chartDataSeries['zIndex'] = 1
            }
            return chartDataSeries
            }
        )

        this.setState({
            chartOptions: {
                chart: {
                    type: 'spline',
                    zoomType: 'x',
                    ignoreHiddenSeries: false,
                    marginRight: 30,
                    resetZoomButton: {
                        theme: {
                            fill: 'white',
                            stroke: 'silver',
                            r: 0,
                            states: {
                                hover: {
                                    fill: '#41739D',
                                    style: {
                                        color: 'white'
                                    }
                                }
                            }
                        }
                    }
                },
                title: null,
                subtitle: null,
                xAxis: {
                    lineColor: '#c0c0c0',
                    type: 'datetime',
                    minorGridLineColor: '#E0E0E0',
                    minorTickLength: 0,
                    gridLineWidth: 0.3,
                    showFirstLabel: true,
                    dateTimeLabelFormats: {
                        second: '%l:%M:%S%P',
                        minute: '%l:%M%P',
                        hour: '%H:%M',
                        day: '<br/><b>%e/%b</b>',
                        week: '%e. %b',
                        month: '%b %y',
                        year: '%Y'
                    },
                    plotBands: arrayChartDataMarked
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: `${t("response-time-for-step.graph.tooltip.point-format")}`
                    },
                    plotBands: [{
                        color: '#C0DAF0',
                        from: externalData.Objetivo.Promedio - externalData.Objetivo.Desviación_Estandar,
                        to: externalData.Objetivo.Promedio + externalData.Objetivo.Desviación_Estandar,
                        zIndex: 0
                    }],
                    plotLines: [{
                        value: sla_rendimiento_ok,
                        color: '#54a51c',
                        width: 2,
                        zIndex: 3
                    }, {
                        value: sla_rendimiento_error,
                        color: '#D22129',
                        width: 2,
                        zIndex: 3
                    }, {
                        value: externalData.Objetivo.Promedio,
                        color: '#00529e',
                        width: 2,
                        zIndex: 3,
                    }]

                },
                credits: {
                    enabled: false
                },        
                plotOptions: {
                    series: {
                        turboThreshold: 20000,
                        gapSize: 2,
                        marker: {
                            symbol: 'circle',
                            width: 8,
                            height: 8,
                            enabled: false
                        },
                        point: {
                            events: {
                                mouseOver: this.setHoverData.bind(this)
                            }
                        }

                    }
                },
                navigator: {
                    enabled: ValueNavigator      
                },
                series: arrayChartData,
                tooltip: {
                    enabled: false,
                    xDateFormat: '%d/%b/%Y %H:%M',
                    pointFormat: t("response-time-for-step.graph.tooltip.point-format")+': <b>{point.y:.2f} (s)</b>'
                },
                legend: {
                    enabled: true,
                    useHTML: true,
                    symbolWidth: 0,
                    labelFormatter: function() {
                        let symbol = '<div style="background:' + this.color + ';width:15px;height:3px;margin-top:5px"></div>'
                        let name= '<button style="padding-left:4px;border-width:0px;background:white">'+this.name+'</button>'
                        return '<div style="display: flex;flex-direction: row;flex-wrap: nowrap;justify-content: space-between;">' + symbol + ' ' + name + '</div>'
                    }
                },
            },
            dataError: false,
            isLoading: false,
            lastEvent: lastEventDict,
            time: period,
            step: step,
            chartOptionsBase: {
                ...this._chartOptionsBase(),
                xAxis: {
                    ...this._chartOptionsBase().xAxis,
                    plotBands: arrayChartDataMarked
                },
                yAxis: {
                    ...this._chartOptionsBase().yAxis,
                    plotBands: [{
                        color: '#C0DAF0',
                        from: externalData.Objetivo.Promedio - externalData.Objetivo.Desviación_Estandar,
                        to: externalData.Objetivo.Promedio + externalData.Objetivo.Desviación_Estandar,
                        zIndex: 0
                    }],
                    plotLines: [{
                        value: sla_rendimiento_ok,
                        color: '#54a51c',
                        width: 2,
                        zIndex: 3
                    }, {
                        value: sla_rendimiento_error,
                        color: '#D22129',
                        width: 2,
                        zIndex: 3
                    }, {
                        value: externalData.Objetivo.Promedio,
                        color: '#00529e',
                        width: 2,
                        zIndex: 3,
                    }]
                },
                series: arrayChartData
            }
        });
    }
    render() {
        const { dataError, chartOptions, isLoading ,chartOptionsBase,step} = this.state;
        
        const style = isLoading ? { display: 'none' } : {};
        const styleHidden = isLoading ? {} : { display: 'none' };
        const t = (this.props && this.props.t) ? this.props.t : (s => s);
        if (isLoading) {
            return (
                <PortletContent>
                    <PerfectScrollbar>
                        <Typography
                            variant="h5"
                            >
                            <CircularProgress
                            variant="indeterminate"
                            size={24}
                            thickness={4}                            
                            />
                            <br/>
                            {t('text.loading')}
                        </Typography>
                    </PerfectScrollbar>
                </PortletContent>
            )
        }
        if (!dataError) {
            sessionStorage.setItem("chartResponseTimeForStep"+String(step),JSON.stringify(chartOptionsBase))
            return (<FormattedChart chartOptions={chartOptions} style={style} styleHidden={styleHidden} />)
        }
        else if (dataError) {
            return (<p>{t('text.no-data')}</p>)
        }
        else return (<p>{t('response-time-for-step.error')}</p>)

    }
}

function FormattedChart(props) {
    const { t } = useTranslation()
    return (
        <div style={props.style}>
            <HighchartsReact
                highcharts={Highcharts}
                options={props.chartOptions}
            />
        </div>
    )
}

export default compose(withRouter, withTranslation())(ResponseTimeForStep);